import { render } from "./ManagementPageWithActions.vue?vue&type=template&id=d647257e&scoped=true&lang=pug"
import script from "./ManagementPageWithActions.vue?vue&type=script&lang=js"
export * from "./ManagementPageWithActions.vue?vue&type=script&lang=js"

import "./ManagementPageWithActions.vue?vue&type=style&index=0&id=d647257e&lang=scss"
import "./ManagementPageWithActions.vue?vue&type=style&index=1&id=d647257e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d647257e"]])

export default __exports__